export const MissingIntegrationTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Click</span> on your avatar in the top right-hand corner of the
                Solar Insure platform.
            </li>
            <li>
                From the dropdown menu that appears, <span className="font-semibold">select </span>
                the <span className="font-semibold">"Profile"</span> option.
            </li>
            <li>
                Once in your profile, <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">"Integrations"</span> tab.
            </li>
            <li>
                Carefully <span className="font-semibold">check</span> that all required credentials fields are
                filled out correctly. <span className="font-semibold">Ensure</span> there are no error messages
                indicating invalid field values.
            </li>
            <li>
                If you made any changes or updates to the credentials, be sure
                to <span className="font-semibold">save</span> these changes before exiting.
            </li>
            <li>
                After updating your credentials, Solar Insure will attempt to connect sites to the monitoring
                for the related manufacturer. Please allow up to 10 days for this process to complete, assuming
                there are no additional issues.
            </li>
        </ul>
    </div>
